export default __webpack_public_path__ + "static/media/100.99ff0957.webp";